export default {
    type: 'toggle',
    format: {},
    default: {
        logic: 'match',
        value: 'yes'
    },
    setting: {
        logic: []
    },
    options: {
        yes: 'Yes'
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Exclude Expansions',
        category: 'Game',
        description: 'Do not include expansions in the results.',
        summarise: {
            template: {
                yes: 'Exclude if expansion'
            }
        }
    },
    rules: {
        linked: [],
        legacy: ['expansions']
    }
}